import { render } from "./FlexBox.vue?vue&type=template&id=c6aa3eac&scoped=true"
const script = {}

import "./FlexBox.vue?vue&type=style&index=0&id=c6aa3eac&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/huwei-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6aa3eac"]])

export default __exports__